import { useState, useEffect } from "react";
import EnableFlow from "./enableFlow";
import DisableFlow from "./disableFlow";
import LoginService from "../../../services/login/loginService";
import useDocumentTitle from "../../../utils/useDocumentTitle";

const ExternalTOTP = () => {
    const [totpFlow, setTotpFlow] = useState("Enable");
    useDocumentTitle("TOPTP");
    useEffect(() => {
        const etotpEnabled = LoginService.getAccData("accs").etotpSwitch;
        if(etotpEnabled == true){
            let etotpFlow = LoginService.getAccData("accs").totpCode;
            let acntTyp = LoginService.getAccData("accTyp");
            if(acntTyp === "COMEQ")
                acntTyp = localStorage.getItem("accntTyp");
            if(acntTyp === "EQ")
                etotpFlow.etotpEnabled ? setTotpFlow("Disable") : setTotpFlow("Enable");
            else if(acntTyp === "CO")
                etotpFlow.etotpEnabled ? setTotpFlow("Disable") : setTotpFlow("Enable"); 
        } 
    }, );
    
    return (
        <>
        {totpFlow==="Enable" && 
            <EnableFlow/>
        }
        {totpFlow==="Disable" && 
            <DisableFlow/>
        }
        </>
    )
}
export default ExternalTOTP;